import {
  EAdvertisingService,
  EAgencies,
  ECountries,
} from "../types/common.types";
import { ECurrency } from "../types/currency.types";
import { EIconNames } from "../types/iconNames";

export const agenciesCountry: Record<EAgencies, ECountries | null> = {
  [EAgencies.Webcom_BY]: ECountries.BY,
  [EAgencies.IContext]: ECountries.BY,
  [EAgencies.Webcom_RU]: ECountries.RU,
  [EAgencies.Webcom_KZ]: null,
  [EAgencies.Digital]: null,
};

export const agencyLogos = {
  [EAgencies.Webcom_BY]: EIconNames.WEBCOM_LOGO_SHORT,
  [EAgencies.Webcom_RU]: EIconNames.WEBCOM_LOGO_SHORT,
  [EAgencies.Digital]: EIconNames.WEBCOM_LOGO_SHORT,
  [EAgencies.Webcom_KZ]: EIconNames.WEBCOM_LOGO_SHORT,
  [EAgencies.IContext]: EIconNames.ICONTEXT,
};

export const advertisingServiceLogos = {
  [EAdvertisingService.Google]: EIconNames.GOOGLE_ADS,
  [EAdvertisingService.Yandex]: EIconNames.YANDEX,
  [EAdvertisingService.FB]: EIconNames.FB,
  [EAdvertisingService.VK]: EIconNames.VK,
  [EAdvertisingService.TikTok]: EIconNames.TIKTOK,
  [EAdvertisingService.Mailru]: EIconNames.MAILRU,
  [EAdvertisingService.Snapchat]: EIconNames.SNAPCHAT,
  [EAdvertisingService.Linkedin]: EIconNames.LINKEDIN,
  [EAdvertisingService.Twitter]: EIconNames.TWITTER,
  [EAdvertisingService.Vkads]: EIconNames.VK,
  [EAdvertisingService.Telegram]: EIconNames.TELEGRAM,
  [EAdvertisingService.YBusines]: EIconNames.YBUSINESS,
  [EAdvertisingService.YNavigator]: EIconNames.YNAVIGATOR,
  [EAdvertisingService.Market]: undefined,
  [EAdvertisingService.Undefined]: undefined,
};

export const defaultAgenciesCurrencies: Record<EAgencies, ECurrency> = {
  [EAgencies.Webcom_BY]: ECurrency.BYN,
  [EAgencies.Webcom_RU]: ECurrency.RUB,
  [EAgencies.Webcom_KZ]: ECurrency.RUB,
  [EAgencies.IContext]: ECurrency.BYN,
  [EAgencies.Digital]: ECurrency.BYN,
};
